// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 872) return "bundle-legacy.css";
	// return url for filenames based on template
	return undefined;
};